<template>
  <div>
    <VueFinalModal
      v-model="showTerminos"
      :esc-to-close="false"
      :click-to-close="false"
      :prevent-click="false"
      class="modal-container"
      content-class="modal-content"
    >
      <span class="modal__title">Términos y condiciones de uso</span>
      <div class="modal__content">
        <p style="font-size: 12px; text-align: justify">
          En mi calidad de usuario (en adelante "el usuario" o "usuario") de
          esta plataforma (en adelante plataforma "PLANPRO") de titularidad de
          PLANPROCAD S.A., reconozco expresamente que al utilizarla debo
          sujetarme en todo momento a lo aquí establecido. Al acceder o utilizar
          esta plataforma web,
          <b
            >acepto expresa, libre y voluntariamente los siguientes Términos y
            Condiciones de Uso.</b
          >
        </p>
        <p style="font-size: 12px; text-align: justify">
          Reconozco y acepto que la plataforma PLANPRO en la persona de su
          administrador o titular, se reserva el derecho de negarme el acceso a
          la misma en cualquier caso que considere apropiado, en particular si
          yo como usuario:
        </p>

        <div style="font-size: 12px; text-align: justify">
          <ol>
            <li>Proporciono <b>datos falsos</b></li>
            <li>
              <b>Incumplo</b> estos Términos y Condiciones de Uso de cualquier
              forma; y,
            </li>
            <li>
              Incumplo <b>cualquier normativa legal</b> aplicable respecto del
              acceso o el uso de la presente plataforma.
            </li>
          </ol>
        </div>

        <p style="font-size: 12px; text-align: justify">
          Acepto libre, voluntaria y expresamente que soy el único responsable
          del contenido que cargue, publique, envíe por correo electrónico,
          transmita o de cualquier forma ponga a disposición a través de esta
          plataforma.
        </p>

        <p style="font-size: 12px; text-align: justify">
          Adicionalmente me obligo expresa, libre y voluntariamente a
          <b
            >no utilizar la presente plataforma en forma alguna que sirva
            directa o indirectamente para:</b
          >
        </p>

        <div style="font-size: 12px; text-align: justify">
          <ul>
            <li>Dañar a otras personas o animales de cualquier forma;</li>
            <li>Realizar declaraciones falsas;</li>
            <li>
              Difundir de cualquier forma contenido que viole un derecho de
              propiedad intelectual de terceros, incluyendo pero no limitado a
              marcas, derechos de autor, secretos empresariales, patentes y
              diseños industriales; y,
            </li>
            <li>
              Violar cualquier ley o norma jurídica nacional o internacional.
            </li>
          </ul>
        </div>

        <p style="font-size: 12px; text-align: justify">
          Reconozco y acepto que la plataforma PLANPRO en la persona de su
          administrador o titular se reserva el derecho de modificar a su
          discreción los presentes términos y condiciones, comunicándome el
          particular, siempre de acuerdo con la ley ecuatoriana.
        </p>

        <p style="font-size: 12px; text-align: justify">
          <b>Datos Personales:</b> Autorizo expresamente a PLANPROCAD S.A. a
          utilizar mis datos personales entregados o generados por medio de mi
          utilización de la plataforma PLANPRO. Esta autorización incluye los
          siguientes usos:
        </p>

        <div style="font-size: 12px; text-align: justify">
          <ul>
            <li>Acceso a datos;</li>
            <li>Consulta de buró crediticio;</li>
          </ul>
        </div>
      </div>
      <div class="modal__action">
        <div class="row">
          <div
            class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
            align="center"
          >
            <button
              v-if="isRegistering"
              type="button"
              class="btn btn-primary"
              @click="sendDataDni"
              style="width: 100%"
            >
              Confirmar
            </button>

            <div
              v-else
              style="
                display: flex;
                justify-content: center;
                align-items: center;
              "
              class="btn btn-primary"
            >
              <i class="fas fa-spinner fa-pulse" style="margin-right: 8px"></i>
              <p
                style="
                  margin: 0;
                  color: white;
                  font-size: 14px;
                  font-weight: 700;
                "
              >
                Espere...
              </p>
            </div>
          </div>
        </div>
      </div>
    </VueFinalModal>
    <div>
      <div class="container-fluid">
        <div
          class="row vh-100"
          style="
            min-height: calc(var(--vh, 1vh) * 100);
            margin: 0px;
            overflow-y: auto;
          "
        >
          <div
            class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex d-sm-flex d-md-flex d-md-flex d-lg-flex d-xl-flex justify-content-center text-center align-items-center"
          >
            <div
              class="row align-items-center col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
            >
              <div class="col-12 col-md-12 col-lg-12">
                <span class="text-primary">
                  <img
                    src="../../src/assets/img/Saludsa/logo_new_saludsa_vertical.png"
                    style="width: 230px"
                  />
                </span>

                <form
                  class="registerFormContainer"
                  @submit.prevent="requestIdentification"
                >
                  <h5
                    class="mt-3"
                    style="text-align: center; margin-bottom: 15px"
                  >
                    Información de Perfil
                  </h5>

                  <p
                    class="text-center"
                    style="
                      font-size: 14px;
                      margin: 0;
                      color: #333333;
                      font-weight: 600;
                    "
                  >
                    Iniciarás sesión como:
                  </p>
                  <p
                    class="text-center"
                    style="
                      font-size: 16px;
                      margin: 0;
                      color: #3c69c1;
                      font-weight: 600;
                    "
                  >
                    {{ this.email }}
                  </p>
                  <button
                    type="button"
                    class="text-center changeMailBtn"
                    @click="resetLoginData"
                  >
                    Iniciar con otro Correo
                  </button>

                  <p
                    class="text-center"
                    style="
                      font-size: 14px;
                      margin: 12px 0 0 0;
                      color: #333333;
                      font-weight: 600;
                    "
                  >
                    Selecciona el Tipo de Persona:
                  </p>
                  <div class="accountTypeContainer">
                    <div
                      class="cardRegister"
                      :class="this.accountType === 'natural' ? 'selected' : ''"
                      @click="toggleAccountType('natural')"
                    >
                      <i class="fa-regular fa-user" style="font-size: 28px"></i>
                      <p
                        class="text-center"
                        style="font-size: 12px; margin: 12px 0 0 0"
                        :class="
                          this.accountType === 'natural' ? 'selected' : ''
                        "
                      >
                        Natural
                      </p>
                    </div>
                    <div
                      class="cardRegister"
                      :class="this.accountType === 'empresa' ? 'selected' : ''"
                      @click="toggleAccountType('empresa')"
                    >
                      <i
                        class="fa-solid fa-building"
                        style="font-size: 28px"
                      ></i>
                      <p
                        class="text-center"
                        :class="
                          this.accountType === 'empresa' ? 'selected' : ''
                        "
                        style="font-size: 12px; margin: 12px 0 0 0"
                      >
                        Jurídica
                      </p>
                    </div>
                  </div>

                  <div
                    style="
                      margin: 12px 0 6px 0;
                      width: 100%;
                      display: flex;
                      justify-content: center;
                    "
                  >
                    <div
                      class="form-check"
                      style="
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        justify-content: center;
                      "
                    >
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="prestadorRefiereYGana"
                        id="prestadorRefiereYGanaCheckbox"
                        style="
                          margin: 0;
                          width: 18px;
                          height: 18px;
                          flex-shrink: 0;
                          cursor: pointer;
                        "
                      />
                      <label
                        class="form-check-label"
                        for="prestadorRefiereYGanaCheckbox"
                        style="
                          font-size: 11px;
                          color: #666;
                          margin: 0;
                          display: flex;
                          align-items: center;
                          gap: 4px;
                        "
                      >
                        Soy prestador
                      </label>
                      <span
                        class="prestador-info-trigger"
                        role="button"
                        tabindex="0"
                        aria-label="Información sobre prestadores"
                        @click.stop="prestadorInfoOpen = !prestadorInfoOpen"
                        @mouseenter="prestadorInfoOpen = true"
                        @mouseleave="prestadorInfoOpen = false"
                        @keydown.enter.prevent="
                          prestadorInfoOpen = !prestadorInfoOpen
                        "
                        @keydown.space.prevent="
                          prestadorInfoOpen = !prestadorInfoOpen
                        "
                      >
                        <i class="fas fa-info-circle prestador-info-icon"></i>
                        <span
                          v-show="prestadorInfoOpen"
                          class="prestador-info-tooltip"
                        >
                          Selecciona esta opción si eres prestador y tienes un
                          convenio con Saludsa.
                        </span>
                      </span>
                    </div>
                  </div>

                  <div
                    v-if="prestadorRefiereYGana"
                    style="
                      margin: 8px 0;
                      width: 100%;
                      display: flex;
                      justify-content: center;
                    "
                  >
                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                        width: 100%;
                        max-width: 280px;
                      "
                    >
                      <label
                        for="regionRygSelect"
                        style="
                          text-align: start;
                          margin-bottom: 4px;
                          font-size: 11px;
                          color: #666;
                        "
                      >
                        ¿De donde eres?
                      </label>
                      <select
                        id="regionRygSelect"
                        class="form-control"
                        v-model="regionRyg"
                        required
                        style="font-size: 12px"
                      >
                        <option value="" disabled selected hidden>
                          Selecciona una región
                        </option>
                        <option value="costa">Costa</option>
                        <option value="sierra">Sierra</option>
                        <option value="provincias">Provincias</option>
                      </select>
                    </div>
                  </div>

                  <div
                    style="
                      margin: 8px 0;
                      display: flex;
                      flex-direction: column;
                      align-items: flex-start;
                    "
                    class="col-11 col-sm-7 col-md-4 col-lg-3 col-xl-3"
                  >
                    <label
                      style="
                        text-align: start;
                        margin-bottom: 0;
                        margin-top: 6px;
                      "
                    >
                      Número de
                      {{ this.accountType === "empresa" ? "RUC" : "Cédula" }}:
                    </label>
                    <input
                      v-if="this.accountType === 'natural'"
                      required
                      placeholder="Número de Cédula Ej: 0912345678"
                      class="form-control"
                      type="text"
                      autocomplete="off"
                      maxlength="10"
                      @input="validateCedula"
                      v-model="idNumber"
                      :disabled="naturalData"
                    />
                    <input
                      v-else
                      required
                      placeholder="Número de RUC Ej: 0912345678001`"
                      class="form-control"
                      type="text"
                      autocomplete="off"
                      maxlength="13"
                      @input="validateRUC"
                      :disabled="companyData"
                      v-model="idNumber"
                    />
                    <p style="font-size: 12px; color: red" v-if="this.message">
                      {{ this.message }}
                    </p>
                  </div>

                  <button
                    v-if="!naturalData && !companyData"
                    class="btn-primary btn col-11 col-sm-7 col-md-4 col-lg-3 col-xl-3"
                    id="btn_submit"
                    style="margin-top: 16px"
                    :disabled="!validId || requesting"
                  >
                    Consultar
                  </button>
                </form>

                <div
                  v-if="naturalData"
                  style="
                    margin: 0 auto;
                    display: flex;
                    flex-direction: column;
                    align-items: start;
                  "
                  class="col-11 col-sm-7 col-md-4 col-lg-3 col-xl-3"
                >
                  <form @submit.prevent="showTermsModal" style="width: 100%">
                    <div
                      style="
                        margin: 8px 0;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                      "
                      class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                    >
                      <label
                        style="
                          text-align: start;
                          margin-bottom: 0;
                          margin-top: 6px;
                        "
                        >Nombre:
                      </label>
                      <p
                        class="form-control formDisabled"
                        style="
                          margin-top: 4px;
                          margin-bottom: 0px;
                          text-align: start;
                        "
                      >
                        {{ this.naturalData.name }}
                      </p>
                    </div>
                    <!-- <div
                      style="
                        margin: 8px 0;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                      "
                      class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                    >
                      <label
                        style="
                          text-align: start;
                          margin-bottom: 0;
                          margin-top: 6px;
                        "
                        >Ciudad:
                      </label>
                      <p
                        class="form-control formDisabled"
                        style="
                          margin-top: 4px;
                          margin-bottom: 0px;
                          text-align: start;
                        "
                      >
                        {{ this.naturalData.city }}
                      </p>
                    </div> -->
                    <div
                      style="
                        margin: 8px 0;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                      "
                      class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                    >
                      <label
                        style="
                          text-align: start;
                          margin-bottom: 0;
                          margin-top: 6px;
                        "
                        >Fecha de Nacimiento:
                      </label>
                      <p
                        class="form-control formDisabled"
                        style="
                          margin-top: 4px;
                          margin-bottom: 0px;
                          text-align: start;
                        "
                      >
                        {{ this.naturalData.birthDate }}
                      </p>
                    </div>
                    <div
                      style="
                        margin: 8px 0;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                      "
                      class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                    >
                      <label
                        style="
                          text-align: start;
                          margin-bottom: 0;
                          margin-top: 6px;
                        "
                        >Correo Electrónico:
                      </label>
                      <p
                        class="form-control formDisabled"
                        style="
                          margin-top: 4px;
                          margin-bottom: 0px;
                          text-align: start;
                        "
                      >
                        {{ this.naturalData.email }}
                      </p>
                    </div>
                    <div
                      style="
                        margin: 8px 0;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                      "
                      class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                    >
                      <label
                        style="
                          text-align: start;
                          margin-bottom: 0;
                          margin-top: 6px;
                        "
                        >Celular:
                      </label>
                      <MazPhoneNumberInput
                        type="tel"
                        default-country-code="EC"
                        :country-locale="phoneCountryLocale"
                        :preferred-countries="preferredPhoneCountries"
                        style="width: 100%; box-sizing: border-box"
                        orientation="col"
                        no-example
                        required
                        show-code-on-list
                        countrySelectorWidth="90px"
                        block
                        v-model="this.naturalData.phone"
                        @update="results = $event"
                        :translations="{
                          countrySelector: {
                            placeholder: 'Código',
                            error: 'Elija un pais',
                          },
                          phoneInput: {
                            placeholder: 'Nro. celular',
                            example: 'Ejemplo:',
                          },
                        }"
                      />
                    </div>
                    <!-- <div
                      style="
                        margin: 8px 0;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                      "
                      class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                      v-if="isProvider"
                    >
                      <label
                        for="provider"
                        style="
                          text-align: start;
                          margin-bottom: 0;
                          margin-top: 6px;
                        "
                      >
                        Prestador:
                      </label>
                      <div class="col-sm-12">
                        <v-select
                          v-model="selectedProvider"
                          placeholder="Seleccionar prestador"
                          class="my-custom-v-select"
                          label="providerName"
                          :options="providers"
                          @option:selected="selectProvider"
                        >
                          <template #search="{ attributes, events }">
                            <input
                              class="vs__search"
                              v-bind="attributes"
                              v-on="events"
                            />
                          </template>
                        </v-select>
                      </div>
                       <label
                        for="provider"
                        style="
                          text-align: start;
                          margin-bottom: 0;
                          margin-top: 6px;
                        "
                        >Prestador:</label
                      >
                      <select
                        v-model="selectedProvider"
                        placeholder="Seleccionar prestador"
                        class="form-control"
                        required
                      >
                        <option value="null" disabled selected hidden>
                          Seleccionar prestador
                        </option>
                        <option
                          v-for="provider in providers"
                          :key="provider.providerDni"
                          :value="provider"
                        >
                          {{ provider.providerName }}
                        </option>
                      </select> 
                    </div> -->
                    <div class="col-12" style="margin-top: 4px">
                      <argon-button
                        class="mt-1"
                        variant="gradient"
                        color="success"
                        style="width: 100%"
                        type="submit"
                        size="md"
                        id="registerBtn1"
                        :disabled="isRegistering || !isFormValid"
                      >
                        Registrar
                        <i class="fa fa-check" style="padding-left: 10px"></i>
                      </argon-button>
                    </div>
                  </form>
                </div>

                <div
                  v-if="companyData"
                  style="
                    margin: 0 auto;
                    display: flex;
                    flex-direction: column;
                    align-items: start;
                  "
                  class="col-11 col-sm-7 col-md-4 col-lg-3 col-xl-3"
                >
                  <form @submit.prevent="showTermsModal" style="width: 100%">
                    <div
                      style="
                        margin: 8px 0;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                      "
                      class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                    >
                      <label
                        style="
                          text-align: start;
                          margin-bottom: 0;
                          margin-top: 6px;
                        "
                        >Razón Social:
                      </label>
                      <p
                        class="form-control formDisabled"
                        style="
                          margin-top: 4px;
                          margin-bottom: 0px;
                          text-align: start;
                        "
                      >
                        {{ this.companyData.displayName }}
                      </p>
                    </div>
                    <!-- <label
                  style="text-align: start; margin-bottom: 0; margin-top: 6px"
                  >Estado del RUC:
                </label>
                <p
                  class="form-control formDisabled"
                  style="margin-top: 4px; margin-bottom: 0px; text-align: start"
                >
                  {{ this.companyData.stateRuc }}
                </p> -->
                    <div
                      style="
                        margin: 8px 0;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                      "
                      class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                    >
                      <label
                        style="
                          text-align: start;
                          margin-bottom: 0;
                          margin-top: 6px;
                        "
                        >Correo Electrónico:
                      </label>
                      <p
                        class="form-control formDisabled"
                        style="
                          margin-top: 4px;
                          margin-bottom: 0px;
                          text-align: start;
                        "
                      >
                        {{ this.companyData.email }}
                      </p>
                    </div>
                    <div
                      style="
                        margin: 8px 0;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                      "
                      class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                    >
                      <label
                        style="
                          text-align: start;
                          margin-bottom: 0;
                          margin-top: 6px;
                        "
                        >Celular:
                      </label>
                      <MazPhoneNumberInput
                        type="tel"
                        default-country-code="EC"
                        :country-locale="phoneCountryLocale"
                        :preferred-countries="preferredPhoneCountries"
                        style="width: 100%; box-sizing: border-box"
                        orientation="col"
                        no-example
                        required
                        show-code-on-list
                        size="sm"
                        countrySelectorWidth="90px"
                        block
                        v-model="phone"
                        @update="results = $event"
                        :translations="{
                          countrySelector: {
                            placeholder: 'Código',
                            error: 'Elija un pais',
                          },
                          phoneInput: {
                            placeholder: 'Nro. celular',
                            example: 'Ejemplo:',
                          },
                        }"
                      />
                    </div>
                    <div
                      style="
                        margin: 8px 0 12px 0;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                      "
                      class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                      v-if="isProvider"
                    >
                      <label
                        for="provider"
                        style="
                          text-align: start;
                          margin-bottom: 0;
                          margin-top: 6px;
                        "
                      >
                        Prestador:
                      </label>
                      <div class="col-sm-12">
                        <v-select
                          v-model="selectedProvider"
                          placeholder="Seleccionar prestador"
                          class="my-custom-v-select"
                          label="providerName"
                          :options="providers"
                          @option:selected="selectProvider"
                        >
                          <template #search="{ attributes, events }">
                            <input
                              class="vs__search"
                              v-bind="attributes"
                              v-on="events"
                            />
                          </template>
                        </v-select>
                      </div>
                      <!-- <label
                        for="province"
                        style="
                          text-align: start;
                          margin-bottom: 0;
                          margin-top: 6px;
                        "
                        >Prestador:</label
                      >
                      <select
                        v-model="selectedProvider"
                        placeholder="Seleccionar prestador"
                        class="form-control"
                        required
                      >
                        <option value="null" disabled selected hidden>
                          Seleccionar prestador
                        </option>
                        <option
                          v-for="provider in providers"
                          :key="provider.providerDni"
                          :value="provider"
                        >
                          {{ provider.providerName }}
                        </option>
                      </select> -->
                    </div>

                    <div class="col-12" style="margin-top: 4px">
                      <argon-button
                        class="mt-1"
                        id="registerBtn2"
                        variant="gradient"
                        color="success"
                        style="width: 100%"
                        type="submit"
                        size="lg"
                        :disabled="isRegistering || !isFormValid"
                      >
                        <i class="fa fa-check" style="padding-right: 10px"></i
                        >Registrar
                      </argon-button>
                    </div>
                  </form>
                </div>

                <hr class="horizontal dark" style="margin-top: 35px" />

                <a
                  target="_blank"
                  title="Facebook de Saludsa Refiere y Gana"
                  href="https://www.facebook.com/"
                >
                  <i class="fab fa-facebook-f redes" aria-hidden="true"></i>
                </a>
                <a
                  target="_blank"
                  title="Instagram de Saludsa Refiere y Gana"
                  href="https://www.instagram.com/"
                >
                  <i class="fab fa-instagram redes" aria-hidden="true"></i>
                </a>
                <a
                  target="_blank"
                  title="Email de Saludsa Refiere y Gana"
                  href="mailto:info@planproec.com?Subject=Tengo%20una%20pregunta"
                >
                  <i class="fas fa-envelope redes" aria-hidden="true"></i>
                </a>
                <a
                  target="_blank"
                  title="Tiktok de Saludsa Refiere y Gana"
                  href="https://www.tiktok.com/"
                >
                  <i class="fa-brands fa-tiktok redes" aria-hidden="true"></i>
                </a>

                <p style="margin-top: 10px; margin-bottom: 0; font-size: 12px">
                  <a
                    href="https://firebasestorage.googleapis.com/v0/b/saludsapro.appspot.com/o/legalDocuments%2FTyCs_RefiereyGana_Saludsa_Ecija_rCEV.pdf?alt=media&token=7adbf25f-5531-49ab-b56a-bd0217206fb7"
                    target="_blank"
                    >Términos y condiciones</a
                  >
                  -
                  <a
                    href="https://www.saludsa.com/wp-content/uploads/2026/02/Poli%CC%81tica-de-privacidad.pdf"
                    target="_blank"
                    >Política de privacidad</a
                  >
                  <!-- -
                  <a
                    href="https://firebasestorage.googleapis.com/v0/b/saludsapro.appspot.com/o/legalDocuments%2FAVISO%20LEGAL.pdf?alt=media&token=6626e7a7-e9da-426c-917b-35e9a14b8d5a"
                    target="_blank"
                    >Aviso legal</a
                  >-
                  <a
                    href="https://firebasestorage.googleapis.com/v0/b/saludsapro.appspot.com/o/legalDocuments%2FDISCLAIMER.pdf?alt=media&token=f1449eb5-6bb2-4866-a8ca-4ffd541191cf"
                    target="_blank"
                    >Disclaimer</a
                  > -->
                </p>

                <p
                  style="margin-top: 0px; font-size: 12px; margin-bottom: 10px"
                >
                  Copyright &copy; {{ year }}
                  <a href="https://www.planproec.com" target="_blank"
                    >- PlanPro</a
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import { VueFinalModal } from "vue-final-modal";
import "vue-final-modal/style.css";
import ArgonButton from "@/components/ArgonButton.vue";
import {
  PREFERRED_PHONE_COUNTRIES,
  PHONE_COUNTRY_LOCALE,
} from "@/constants/phoneCountries";

export default {
  name: "Register",
  components: { VueFinalModal, ArgonButton },

  data() {
    let datos = JSON.parse(localStorage.getItem("userData")) || {};

    return {
      phoneCountryLocale: PHONE_COUNTRY_LOCALE,
      preferredPhoneCountries: PREFERRED_PHONE_COUNTRIES,
      results: null,
      loading: true,
      isRegistering: false,
      isMobile: this.$isMobile,
      year: new Date().getFullYear(),
      userId: datos.userLoginId || "",
      tokenAuth: datos.tokenAuth || "",
      email: datos.email || "",
      displayName: "",
      phone: "",
      accountType: "natural",
      idNumber: "",
      validId: false,
      requesting: false,
      naturalData: null,
      companyData: null,
      countryCode: null,
      isDisabled: false,
      phoneNumber: null,
      providers: [],
      selectedProviderId: null,
      selectedProvider: null,
      showTerminos: false,
      isProvider: false,
      prestadorRefiereYGana: false,
      regionRyg: "",
      prestadorInfoOpen: false,
      message: null,
      provider: null,
    };
  },
  computed: {
    isProviderValid() {
      // Validate provider only if isProvider is true
      return (
        !this.isProvider ||
        (this.selectedProvider !== "null" && this.selectedProvider !== null)
      );
    },
    isRegionRygValid() {
      if (!this.prestadorRefiereYGana) return true;
      return ["costa", "sierra", "provincias"].includes(this.regionRyg);
    },
    isFormValid() {
      // General form validation
      return this.isProviderValid && this.isRegionRygValid;
    },
  },
  watch: {
    isProvider(newVal) {
      this.selectedProvider = null;
    },
    prestadorRefiereYGana(newVal) {
      if (!newVal) {
        this.regionRyg = "";
      }
    },
    idNumber(newVal) {
      if (this.idNumber !== "") {
        if (this.accountType === "natural") {
          this.validateCedula();
        } else {
          this.validateRUC();
        }
      }
    },

    accountType() {
      this.idNumber = ""; // Clear the ID number when account type changes
      this.message = ""; // Clear the message when account type changes
    },
    results(newValue) {
      if (!newValue?.isValid || !newValue?.e164) return;

      if (this.accountType === "natural" && this.naturalData) {
        this.naturalData.phone = newValue.e164;
      } else if (this.accountType === "empresa") {
        this.phone = newValue.e164;
      }
    },
  },
  activated() {
    let datos = JSON.parse(localStorage.getItem("userData"));
    this.email = datos.email;
  },
  mounted() {
    if (this.isMobile) {
      this.$eventBus.emit("activeShowMenu");
    }
    this.loadProviders();
  },
  deactivated() {
    this.naturalData = null;
    this.companyData = null;
    this.loading = false;
    this.isDisabled = false;
    this.displayName = null;
    this.phone = null;
    this.accountType = "natural";
    this.idNumber = "";
  },
  methods: {
    async resetLoginData() {
      console.log("Resetting login data...");

      try {
        // Sign out from Firebase
        const { default: firebase } = await import("firebase/compat/app");
        await import("firebase/compat/auth");

        if (firebase.auth().currentUser) {
          await firebase.auth().signOut();
          console.log("Firebase user signed out successfully");
        }
      } catch (error) {
        console.error("Error signing out from Firebase:", error);
      }

      // Clear all local storage
      localStorage.removeItem("userData");
      localStorage.removeItem("session");

      // Reset store state
      this.$store.commit("resetUser");
      this.$store.state.user = "";

      // Reset component data
      this.email = "";
      this.displayName = "";
      this.phone = "";
      this.accountType = "natural";
      this.idNumber = "";
      this.naturalData = null;
      this.companyData = null;

      // Navigate to login page
      this.$router.push("/login");
      console.log("Navigation command executed.");
    },

    /*.then(() => {
        // Force page reload if cached
        this.$router.go(0);
      });*/
    showTermsModal() {
      this.showTerminos = true;
      this.isRegistering = true;
    },

    toggleAccountType(type) {
      this.accountType = type;
      this.naturalData = null;
      this.companyData = null;
    },

    validateRUC() {
      if (!this.idNumber || this.idNumber.length < 13) {
        this.message = "El RUC debe tener exactamente 13 dígitos numéricos.";
        this.validId = false;
      } else if (!this.idNumber.endsWith("001")) {
        this.message = "El RUC debe terminar con '001'.";
        this.validId = false;
      } else {
        this.message = "";
        this.validId = true;
      }
    },

    validateCedula() {
      if (!this.idNumber || this.idNumber.length < 10) {
        this.message = "La Cédula debe tener exactamente 10 dígitos numéricos.";
        this.validId = false;
      } else {
        this.message = "";
        this.validId = true;
      }
    },

    requestIdentification() {
      document.getElementById("btn_submit").innerHTML =
        '<i class="fas fa-spinner fa-pulse"></i> Consultando, espere...';
      this.requesting = true;

      if (this.accountType === "empresa") {
        this.$https
          .post("/consul/srg-verificar-contribuyente", {
            ruc: this.idNumber,
          })
          .then((response) => {
            if (response.data.code === 200 && response.data.preview?.validado) {
              const preview = response.data.preview;

              const estadoLegal = String(
                preview.estadoLegal || preview.estadoContribuyenteRuc || "",
              ).toUpperCase();
              if (estadoLegal !== "ACTIVO" && estadoLegal !== "ACTIVA") {
                this.$toast.error("El RUC no se encuentra activo", {
                  position: "top-right",
                  max: 10,
                });
                this.requesting = false;
                document.getElementById("btn_submit").innerHTML = "Consultar";
                return;
              }

              this.requesting = false;
              this.companyData = {
                displayName: preview.razonSocial,
                dni: this.idNumber,
                email: this.email,
                stateRuc: estadoLegal,
                identidadValidada: true,
              };
            } else if (response.data.code === 204) {
              this.$toast.error(response.data.message, {
                position: "top-right",
                max: 10,
              });
            }
            this.naturalData = null;
            this.requesting = false;
            document.getElementById("btn_submit").innerHTML = "Consultar";
          })
          .catch((error) => {
            const status = error.response?.status;
            const msg =
              error.response?.data?.message ||
              error.response?.data?.error ||
              "No disponemos de información";
            if (status === 403) {
              this.$toast.error(
                "Solo puedes consultar el RUC de tu perfil",
                { position: "top-right", max: 10 },
              );
            } else if (status === 429) {
              this.$toast.error(msg, { position: "top-right", max: 10 });
            } else {
              this.$toast.error(msg, { position: "top-right", max: 10 });
            }
            document.getElementById("btn_submit").innerHTML = "Consultar";
            this.requesting = false;
          });
      } else if (this.accountType === "natural") {
        this.$https
          .post("/consul/srg-verificar-persona", {
            dni: this.idNumber,
          })
          .then((response) => {
            document.getElementById("btn_submit").innerHTML = "Consultar";
            this.requesting = false;

            if (response.data.code === 200 && response.data.preview?.validado) {
              const preview = response.data.preview;
              this.naturalData = {
                name: preview.nombre,
                email: this.email,
                dni: this.idNumber,
                birthDate: preview.fechaNacimiento,
                phone: this.phone,
                identidadValidada: true,
              };
              this.companyData = null;
            } else if (response.data.code === 204) {
              this.$toast.error(response.data.message, {
                position: "top-right",
                max: 10,
              });
              document.getElementById("btn_submit").innerHTML = "Consultar";
              this.requesting = false;
            }
          })
          .catch((error) => {
            document.getElementById("btn_submit").innerHTML = "Consultar";
            this.requesting = false;

            if (error.response?.status === 401) {
              localStorage.removeItem("userData");
              this.$store.state.user = "";
              this.$router.push({ name: "Signin" });
              this.$toast.error("Token caducado, vuelve a iniciar sesión", {
                position: "top-right",
                max: 10,
              });
              return;
            }

            const status = error.response?.status;
            const msg =
              error.response?.data?.message ||
              error.response?.data?.error ||
              "No disponemos de información";

            if (status === 403) {
              this.$toast.error(
                "Solo puedes consultar tu propia cédula",
                { position: "top-right", max: 10 },
              );
            } else if (status === 429) {
              this.$toast.error(msg, { position: "top-right", max: 10 });
            } else {
              this.$toast.error(msg, { position: "top-right", max: 10 });
            }
          });
      }
    },

    sendDataDni() {
      if (this.accountType === "natural") {
        this.isRegistering = false;
        document.getElementById("registerBtn1").innerHTML =
          '<i class="fas fa-circle-notch fa-spin"></i> Registrando...';
        this.$https
          .post("login/registerUser", {
            dni: this.naturalData.dni,
            email: this.naturalData.email,
            phone: this.naturalData.phone,
            city: this.naturalData.city || "",
            provider: this.selectedProvider,
            isProvider: this.isProvider,
            ...(this.prestadorRefiereYGana && {
              prestador_refiere_y_gana: true,
              region_ryg: this.regionRyg,
            }),
          })
          .then((response) => {
            const userRole = this.$encryptBackoffice.encrypt(
              response.data.role,
            );

            localStorage.setItem("session", userRole);
            this.$store.state.user = JSON.stringify({
              ...response.data.datos,
              tokenAuth: this.tokenAuth,
            });
            localStorage.setItem(
              "userData",
              JSON.stringify({
                ...response.data.datos,
                tokenAuth: this.tokenAuth,
              }),
            );

            this.isRegistering = true;
            this.showTerminos = false;
            document.getElementById("registerBtn1").innerHTML =
              'Registrar <i class="fa fa-check" style="padding-left: 10px"></i>';
            this.$toast.success(response.data.message, {
              position: "top-right",
              max: 10,
            });
            this.$router.push({ name: "Dashboard" });
          })
          .catch((error) => {
            this.isRegistering = false;
            this.showTerminos = false;
            document.getElementById("registerBtn1").innerHTML =
              'Registrar <i class="fa fa-check" style="padding-left: 10px"></i>';
            this.$toast.error(error.response.data.message, {
              position: "top-right",
              max: 10,
            });
          });
      } else {
        this.isRegistering = false;
        document.getElementById("registerBtn2").innerHTML =
          '<i class="fas fa-circle-notch fa-spin"></i> Registrando...';
        this.$https
          .post("login/registerCompany", {
            dni: this.companyData.dni,
            email: this.companyData.email,
            phone: this.phone,
            isProvider: this.isProvider,
            provider: this.selectedProvider,
            ...(this.prestadorRefiereYGana && {
              prestador_refiere_y_gana: true,
              region_ryg: this.regionRyg,
            }),
          })
          .then((response) => {
            this.$store.state.user = JSON.stringify({
              ...response.data.datos,
              tokenAuth: this.tokenAuth,
            });
            localStorage.setItem(
              "userData",
              JSON.stringify({
                ...response.data.datos,
                tokenAuth: this.tokenAuth,
              }),
            );
            this.isRegistering = true;
            document.getElementById("registerBtn2").innerHTML =
              'Registrar <i class="fa fa-check" style="padding-left: 10px"></i>';
            this.$toast.success(response.data.message, {
              position: "top-right",
              max: 10,
            });
            this.$router.push({ name: "Dashboard" });
          })
          .catch((error) => {
            this.isRegistering = true;
            document.getElementById("registerBtn2").innerHTML =
              'Registrar <i class="fa fa-check" style="padding-left: 10px"></i>';
            this.$toast.error(error.response.data.message, {
              position: "top-right",
              max: 10,
            });
          });
      }
    },

    loadProviders() {
      this.$https
        .post("/hubspot/fetchProviders", {})
        .then((response) => {
          this.providers = response.data.providers;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    selectProvider(value) {
      console.log("value: ", value);
    },
  },
};
</script>

<!-- if (this.selectedProvider.id === provider.id) {
          this.cities = provider.cities;
          this.selectedCityName = "";
        } -->

<style>
.registerFormContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.accountTypeContainer {
  display: flex;
  justify-content: center;
  align-items: center;
}

.cardRegister {
  margin: 1rem;
  padding: 1rem;
  /* border: 1px solid #ddd; */
  border-radius: 5px !important;
  cursor: pointer;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.12) !important;
}

.cardRegister:hover {
  background-color: rgb(251, 251, 251);
}

.cardRegister-text {
  font-weight: 600;
}

.cardRegister-body {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
}

.formDisabled {
  background-color: #f0f0f0 !important;
  /* Light grey background on hover */
  color: #888 !important;
  /* Lighter text color on hover */
  cursor: not-allowed !important;
}

.selected {
  background-color: #2778c4 !important;
  color: #f7f7f7 !important;
}

.changeMailBtn {
  font-size: 12px;
  margin: 0;
  color: #777777;
  font-weight: 600;
  text-decoration: underline;
}

.changeMailBtn:hover {
  scale: 105%;
  color: #333333;
}

.bg-gradient-success {
  background-image: linear-gradient(
    310deg,
    #08629e 0%,
    #0c75ba 100%
  ) !important;
}
.vs__dropdown-toggle {
  background-color: white !important;
}

.prestador-info-trigger {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: help;
}

.prestador-info-icon {
  font-size: 12px;
  color: #999;
  transition: color 0.15s ease;
}

.prestador-info-trigger:hover .prestador-info-icon,
.prestador-info-trigger:focus .prestador-info-icon {
  color: #2778c4;
}

.prestador-info-tooltip {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  width: max-content;
  max-width: 220px;
  padding: 7px 10px;
  font-size: 10px;
  line-height: 1.35;
  color: #fff;
  background: #333;
  border-radius: 6px;
  z-index: 20;
  text-align: center;
  pointer-events: none;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.18);
}

.prestador-info-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: #333;
}
</style>
